import React from 'react'
import {
  ImageBody,
  ImageContainer,
  ImageWrapper,
  Image,
  ImageButton,
} from 'shared/components/image-container'
import { Button } from 'shared/components'
import GetPhotoFeature from '../../camera/get-photo/get-photo.feature'
import { CommonStepRegistrationProps } from './types'

interface StepPhotoSelfProps extends CommonStepRegistrationProps {
  photoSelf: string
  handlePhotoSelf: (photo: string) => void
  resetPhoto: () => void
}

export function StepPhotoSelf({
  photoSelf,
  handlePhotoSelf,
  resetPhoto,
  handleNext,
}: StepPhotoSelfProps) {
  return (
    <>
      {!photoSelf && (
        <ImageContainer>
          <ImageBody>
            <GetPhotoFeature setPhoto={handlePhotoSelf} />
          </ImageBody>
        </ImageContainer>
      )}

      {photoSelf && (
        <ImageContainer>
          <ImageBody>
            <ImageWrapper>
              <Image src={photoSelf} alt="" />
            </ImageWrapper>
          </ImageBody>
          <ImageButton>
            <Button
              square
              onClick={() => {
                resetPhoto()
              }}
            >
              Reset Photo
            </Button>

            <Button large primary square onClick={() => handleNext && handleNext()}>
              Next
            </Button>
          </ImageButton>
        </ImageContainer>
      )}
    </>
  )
}
